<template>
    <div class="neo-form">
        <neo-form />
    </div>
</template>

<script>
import NeoForm from "@/components/Website/NeoForm.vue";

export default {
  name: "NeoSignupForm",
  components: { NeoForm },
  data() {
    return {};
  },
  computed: {
    validForm() {
      return this.form.email;
    },
  },
  methods: {},
};
</script>

<style lang="scss">
.neo-form {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 20px 25px 30px;
  margin: 20px 0;
  position: relative;
}
</style>
